var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDiscardKpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20203 7.20087C7.44611 6.9568 7.84183 6.9568 8.08591 7.20087L10.001 9.11595L11.9161 7.20087C12.1602 6.9568 12.5559 6.9568 12.8 7.20087C13.044 7.44495 13.044 7.84068 12.8 8.08476L10.8849 9.99984L12.8 11.9149C13.044 12.159 13.044 12.5547 12.8 12.7988C12.5559 13.0429 12.1602 13.0429 11.9161 12.7988L10.001 10.8837L8.08591 12.7988C7.84183 13.0429 7.44611 13.0429 7.20203 12.7988C6.95795 12.5547 6.95795 12.159 7.20203 11.9149L9.11711 9.99984L7.20203 8.08476C6.95795 7.84068 6.95795 7.44495 7.20203 7.20087Z",
    fill: "#2E2E38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 2.2915C5.74411 2.2915 2.29297 5.74264 2.29297 9.99984C2.29297 14.257 5.74411 17.7082 10.0013 17.7082C14.2585 17.7082 17.7096 14.257 17.7096 9.99984C17.7096 5.74264 14.2585 2.2915 10.0013 2.2915ZM1.04297 9.99984C1.04297 5.05229 5.05375 1.0415 10.0013 1.0415C14.9489 1.0415 18.9596 5.05229 18.9596 9.99984C18.9596 14.9474 14.9489 18.9582 10.0013 18.9582C5.05375 18.9582 1.04297 14.9474 1.04297 9.99984Z",
    fill: "#2E2E38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscardKpi);
export default __webpack_public_path__ + "static/media/iconDiscardKPI.95968689f02e685881f1505d9f69eaff.svg";
export { ForwardRef as ReactComponent };